/** 微信开户账号：未绑手机则强制走绑定（方案 A） */
export function needsPhoneBind(input: {
  email?: string | null;
  phoneBound?: boolean | null;
  wxBound?: boolean | null;
}): boolean {
  if (input.phoneBound === true) return false;
  if (input.phoneBound !== false) return false;
  const email = String(input.email || "");
  if (email.endsWith("@wechat.udhub.local")) return true;
  return Boolean(input.wxBound);
}
